import { defineMessages } from 'react-intl'

export default defineMessages({
  search: {
    id: 'containers.SearchPage.search',
    defaultMessage: 'Search',
  },
  count: {
    id: 'containers.SearchPage.count',
    defaultMessage: '{count} found',
  },
  countOf: {
    id: 'containers.SearchPage.countOf',
    defaultMessage: '{from} to {to} of {total}',
  },
  back: {
    id: 'containers.SearchPage.back',
    defaultMessage: 'Show full list',
  },
  reset: {
    id: 'containers.SearchPage.reset',
    defaultMessage: 'Reset',
  },
  prev: {
    id: 'containers.SearchPage.prev',
    defaultMessage: 'Prev',
  },
  next: {
    id: 'containers.SearchPage.next',
    defaultMessage: 'Next',
  },
})
